import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import AlertModal from "../AlertModal";
import { styles } from "./styles";

/**
 * Shown once to a supplier who lands in the app right after joining a
 * community through its invite link: the community's request is already
 * waiting for them in the Join requests tab, and without this they'd just be
 * dropped on the page with no idea what to do next.
 *
 * The action button hands them straight to the offer they have to send.
 */
const JoinRequestReceivedModal = ({
  open,
  onClose,
  onActionClick,
  communityName,
}) => {
  const { t } = useTranslation("join-request-received");

  return (
    <AlertModal
      {...{
        open,
        onClose,
        onActionClick,
        title: t("title"),
        actionBtnText: t("action_button"),
      }}
    >
      <Box sx={styles.content}>
        <Box
          component="img"
          src="/images/clapping-img.png"
          alt=""
          sx={styles.image}
        />

        <Typography sx={styles.heading}>
          {t("heading", { communityName })}
        </Typography>

        <Typography sx={styles.paragraph}>{t("paragraph")}</Typography>
      </Box>
    </AlertModal>
  );
};

export default JoinRequestReceivedModal;
